<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapproveparticipation/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
